module.exports = __webpack_public_path__ + "img/emailEle.e7baba4e.svg";